<template>
  <div class="uploading-attachment" :class="fileList.length ? 'margin-bottom-small' : ''">
    <el-upload ref="uploadAtt" class="newLoad" action="#" :disabled="readonly" list-type="text" :on-change="changeFile" :on-remove="handleRemove" :show-file-list="showFileList" :file-list="fileList" :accept="fileFormat" :auto-upload="false" :multiple="multiple" :limit="limit" :on-exceed="limitTip">
      <el-button size="small" type="primary">文件上传</el-button>
    </el-upload>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';

export default {
  props: {
    showFileList: {
      default: true,
      type: Boolean
    },
    value: {
      default: null,
      type: Array
    },
    readonly: {
      default: () => false,
      type: Boolean
    },
    multiple: {
      default: () => true,
      type: Boolean
    },
    limit: {
      default: () => 10,
      type: Number
    },
    uploadImages: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      fileList: [],
      picturesFormat: '.png,.jpg,.jpeg,.gif',
      fileFormat: '.epub,.pps,.pot,.vsd,.z,.arj,.flac,.ape,.midi,.wma,.avi,.wmv,.mpg,.mpeg,.rm,.ram,.swf,.flv,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.rtf,.jnt,.zip,.rar,.pdf,.mp4,.mov,.wav,.mp3,.amr,.m4a,',
      rule: /\.(epub|pps|pot|vsd|z|arj|flac|ape|midi|wma|avi|wmv|mpg|mpeg|rm|ram|swf|flv|xlsx|xls|doc|docx|ppt|pptx|txt|rtf|jnt|zip|rar|pdf|mp4|mov|wav|mp3|amr|m4a)$/
    };
  },
  watch: {
    value: {
      handler(val) {
        this.fileList = val || [];
        this.$emit('change', this.fileList);
        this.$emit('input', this.fileList);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.uploadImages) {
      this.fileFormat += this.picturesFormat;
      this.rule = /\.(epub|pps|pot|vsd|z|arj|flac|ape|midi|wma|avi|wmv|mpg|mpeg|rm|ram|swf|flv|xlsx|xls|doc|docx|ppt|pptx|txt|rtf|jnt|zip|rar|png|jpg|jpeg|gif|pdf|mp4|mov|wav|mp3|amr|m4a)$/;
    }
  },
  methods: {
    // 设置附件
    changeFile: debounce(function (file, fileList) {
      const fileName = file.name.toLowerCase();
      const isFormat = this.rule.test(fileName);
      if (!isFormat && fileList.length) {
        fileList.splice(fileList.length - 1);
        this.$message({ type: 'warning', message: '上传文件格式错误' });
      } else {
        this.$emit('change', fileList);
        this.$emit('input', fileList);
      }
    }, 100),
    handleRemove(file, fileList) {
      this.$emit('change', fileList);
      this.$emit('input', fileList);
    },
    // 清除上传文件
    clearFiles() {
      this.$refs.uploadAtt.clearFiles();
    },
    limitTip() {
      this.$message({ type: 'warning', message: '最多允许选择10个附件' });
    }
  }
};
</script>

<style lang="less" scoped>
.uploading-attachment {
  margin-top: 20px;
  display: block;
  line-height: 1;
  .newLoad {
    width: 320px;
  }
}
</style>
